module.exports = __webpack_public_path__ + "img/icon_oa.ec27dbb2.png";